import { Injectable, inject, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, of, tap } from 'rxjs';

export interface UserInfo {
  id: number;
  name: string;
  email: string;
  picture: string;
  admin: boolean;
  /** Null solo per una finestra transitoria: assegnato al primo login (vedi AppUserService),
   * quindi assente solo se la sessione e' stata caricata durante quel salvataggio. */
  nickname: string | null;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);

  currentUser = signal<UserInfo | null>(null);
  isAuthenticated = computed(() => this.currentUser() !== null);

  checkAuth(): Promise<void> {
    return new Promise(resolve => {
      this.http.get<UserInfo>('/api/auth/me', { withCredentials: true }).pipe(
        tap(user => this.currentUser.set(user)),
        catchError(() => {
          this.currentUser.set(null);
          return of(null);
        })
      ).subscribe(() => resolve());
    });
  }

  logout(): void {
    this.http.post('/api/auth/logout', {}, { withCredentials: true }).pipe(
      catchError(() => of(null))
    ).subscribe(() => {
      this.currentUser.set(null);
      this.router.navigate(['/login']);
    });
  }
}
